import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  Button,
  ErrorMessage,
  GlobalStyle,
  Input,
  Logo,
  MainContent,
  PageContainer,
  Sidebar,
  Title,
} from "./BetaComponents";
// import { formatPhoneNumberForDisplay, handlePhoneNumberChange } from "./PhoneDisplay";
import VectorMan from "./VectorMan";

const StyledVectorMan = styled(VectorMan)`
  max-width: 500px;
  width: 100%;
  height: auto;
  margin-bottom: 24px;
`;

const GetStartedPage = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleNext = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/get-user', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone_number: phoneNumber }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.detail || 'An error occurred.');
        setLoading(false);
        return;
      }
      // could redirect to OTP for login OR signup page
      navigate(data.redirect_url, { state: data.state });
    } catch (err) {
      setError("An unexpected error occurred. Please try again.");
      setLoading(false);
    }
  };

  return (
    <>
      <GlobalStyle />
      <PageContainer>
        <Sidebar>
          <Logo />
        </Sidebar>
        <MainContent>
          <StyledVectorMan />
          <Title>Enter your phone number to get started</Title>
          <Input
            type="tel"
            placeholder="Your phone number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            disabled={loading}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleNext();
              }
            }}
          />
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <Button onClick={handleNext} disabled={loading}>
            {loading ? "Checking..." : "Next"}
          </Button>
        </MainContent>
      </PageContainer>
    </>
  );
};

export default GetStartedPage;
